import { observer } from "mobx-react-lite";
import React from "react";
import { FormControl } from "react-bootstrap";
import { useFormContext } from "./Form";
import { emptyStringIfNull, withFormWrapper, } from "./withFormWrapper";
import { StaticInputValue } from "./StaticInput";
const RawTextArea = observer(({ name, maxLength, type, rawOnChange, onChange, rawOnBlur, onBlur, disabled, label, staticFormatter, dataId, dataLabel, dataTestId, style, }) => {
    const { values, formDisabled, isStatic } = useFormContext();
    const handleChange = React.useCallback((e) => {
        if (onChange) {
            onChange(e.target.value, values.get(name));
        }
        if (rawOnChange) {
            rawOnChange(e);
        }
        values.set(name, e.target.value);
    }, [onChange, values, name]);
    const handleBlur = React.useCallback((e) => {
        if (onBlur) {
            onBlur(e.target.value, values.get(name));
        }
        if (rawOnBlur) {
            rawOnBlur(e);
        }
        values.set(name, e.target.value);
    }, [onBlur, values, name]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(FormControl, { name: name, type: type, value: emptyStringIfNull(values.get(name)), onChange: handleChange, onBlur: handleBlur, componentClass: "textarea", rows: 5, disabled: disabled || formDisabled, maxLength: maxLength, style: style }));
});
export const TextArea = withFormWrapper({
    WrappedComponent: RawTextArea,
});
